module.exports = __webpack_public_path__ + "static/media/logo.cb2c9e5c.svg";